<template>
  <v-app>
    <v-app-bar app absolute color="primaryDark" dense height="60" class="px-8">
      <router-link to="/" exact class="logo_link">
        <img src="@/assets/img/common/logo_kaii.png" alt="카이아이 로고" style="height: 40px" />
        <span class="blind">덴티하이</span>
      </router-link>
      <div class="tab_wrap d-flex justify-space-between">
        <div class="left_tab_wrap d-flex justify-center">
          <router-link v-for="tab in tabs" :key="tab.id" active-class="active" :to="tab.route" class="white--text tab_item d-flex align-center justify-center">
            {{ tab.name }}
          </router-link>
        </div>
        <div class="right_tab_wrap d-flex justify-center align-center">
          <!--<router-link to="/user/register" class="register_user_link white&#45;&#45;text mr-6 d-flex justify-center">-->
          <!--  <v-icon class="mr-1">mdi-plus</v-icon>-->
          <!--  대상자 등록-->
          <!--</router-link>-->
          <div class="user_menu_wrap">
            <v-menu bottom offset-y transition="slide-y-transition">
              <template #activator="{ on, attrs }">
                <button class="menu_btn d-flex white--text" v-bind="attrs" v-on="on">
                  <span class="text_ellipsis">{{ name }}</span>
                  님
                </button>
              </template>
              <v-list class="menu_list">
                <template v-if="isSuper === 'Y'">
                  <v-list-item exact to="/admin" class="v-list-item--link">관리자 목록</v-list-item>
                  <v-list-item exact to="/admin/register" class="v-list-item--link">관리자 등록</v-list-item>
                </template>
                <v-list-item exact to="/initial" class="v-list-item--link">비밀번호 변경</v-list-item>
                <v-list-item class="v-list-item--link" @click.prevent="$store.dispatch('user/logout')">로그아웃</v-list-item>
              </v-list>
            </v-menu>
          </div>
        </div>
      </div>
    </v-app-bar>
    <v-main class="main_wrap">
      <router-view :key="$route.fullPath"></router-view>
    </v-main>
    <v-footer app absolute color="darkGrey" class="align-center justify-center footer" padless>
      <v-card color="darkGrey" max-width="1360" width="1360" class="py-10">
        <v-card-text class="white--text pa-0 pb-5 1rem company_txt" cols="12">(주)카이아이컴퍼니</v-card-text>
        <v-card-text class="white--text pa-0 d-flex justify-space-between footer_sub_txt">
          <p class="ma-0">
            대표자: 정호정 ㅣ 사업자등록번호: 568-88-00197
            <br />
            주소: 서울시 금천구 가산디지털1로 204, 12층 2~6호 ㅣ 긴급 연락처: 1670-2628
            <br />
            품목명: 치과영상 검출ㆍ진단보조 소프트웨어(2등급) ㅣ 모델명: 덴티하이(Denti-Hi) ㅣ 제조번호(버전): 2.1.0 ㅣ 제조일자(배포) : 2024.05.02
            <br />
            품목허가번호: 허가 후 기재 ㅣ 포장단위: 자사 포장단위에 따름(1 copy) ㅣ 의료기기 UDI: 허가 후 기재
            <strong class="d-block mt-1" style="font-size: 15px">본 제품은 의료기기임</strong>
          </p>
          <p class="ma-0 align-self-center">Copyright 2021 Kai-i co.,ltd all rights reserved.</p>
        </v-card-text>
      </v-card>
    </v-footer>
  </v-app>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'Main',
  data: () => ({
    tabs: [
      { name: '환자 검색', route: `/user` },
      // { name: '관리자 목록', route: `/admin` },
      { name: '통계', route: `/statistics` },
    ],
  }),
  computed: {
    ...mapState('user', ['accessToken', 'name', 'isSuper']),
    ...mapState('commonValue', ['corpsList']),
  },
  created() {
    if (this.corpsList.length === 0) {
      this.fetchCorpsList();
    }
  },
  methods: {
    ...mapActions('commonValue', ['fetchCorpsList']),
  },
};
</script>

<style scoped></style>
